import React, { useState } from "react";
import "./faqs.css";
import Footer from "./footer";
import Navbar from "./navbar";

const Accordion = () => {
	const [activeIndex, setActiveIndex] = useState(null);

	const toggleSection = (index) => {
		setActiveIndex(index === activeIndex ? null : index);
	};

	return (
		<div id="faqs">
			<Navbar />
			<div className="container pt-pb">
				<div className="accordin">
					<div style={{ marginBottom: "10px" }}>
						<h1
							style={{
								marginTop: "-4rem",
								fontSize: "24px",
								fontWeight: "600",
								letterSpacing: "0.5px",
								lineHeight: "24px",
								fontFamily: "Rubik, sans-serif",
								marginBottom: "2rem",
							}}>
							Global Academy for Food Safety and Sustainability Standards
						</h1>
						<h1
							style={{
								fontSize: "22px",
								fontWeight: "600",
								letterSpacing: "0.5px",
								lineHeight: "24px",
								fontFamily: "Rubik, sans-serif",
								marginBottom: "2rem",
							}}>
							General
						</h1>
						<div className="accordin-heading" onClick={() => toggleSection(1)}>
							<strong>
								1. What is the Global Academy for Food Safety and Sustainability
								Standards?
							</strong>
							<span className={`arrow ${activeIndex === 1 ? "open" : ""}`} />
						</div>
						{activeIndex === 1 && (
							<div className="accordin-text">
								<p>
									The Global Academy is an AI-powered online learning platform
									that offers self-paced and instructor-led courses on
									international food safety and sustainability standards. It
									helps farmers, food processors, exporters, and institutions
									build capacity to comply with standards like GlobalG.A.P,
									IndG.A.P, USDA NOP, NPOP, ISO 22000, and more.
								</p>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(2)}>
							<strong>2. Key Objectives of the Platform</strong>
							<span className={`arrow ${activeIndex === 2 ? "open" : ""}`} />
						</div>
						{activeIndex === 2 && (
							<div className="accordin-text">
								<ul>
									<li>
										<strong>Empower a skilled workforce — </strong> Equip
										farmers and processors to meet global standards.
									</li>
									<li>
										<strong> Drive higher incomes — </strong> Unlock premium
										market access for certified produce.
									</li>
									<li>
										<strong> Champion safe, sustainable food — </strong> Build
										trust through quality and compliance.
									</li>
									<li>
										<strong> Enhance climate resilience — </strong> Enable
										carbon credits and sustainable growth.
									</li>
									<li>
										<strong> Strengthen global food security — </strong>
										Position India as a leader in safe, sustainable food.
									</li>
								</ul>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(3)}>
							<strong>3. How do I register for a course Self-Paced?</strong>
							<span className={`arrow ${activeIndex === 3 ? "open" : ""}`} />
						</div>
						{activeIndex === 3 && (
							<div className="accordin-text">
								<p>
									Visit the course catalog on our platform, select the course
									that matches your needs, and follow the simple registration
									and payment process. Once registered, you’ll gain access to
									course materials and resources.
									<br />
									<br />
									<strong>Preview the Course — </strong>
									Review the course overview to see if it aligns with your
									learning needs.
									<br />
									<strong> Register and Pay —</strong> Sign up for the course
									and complete the payment process.
									<br />
									<strong>Access Course Materials —</strong> Study at your own
									pace within the defined time period.
									<br />
									<strong> Final Assessment —</strong>
									{"  "}
									Complete the final assessment within the course period:
								</p>
								<ul style={{ listStyle: "none", paddingLeft: "50px" }}>
									<li>
										✅{"  "}
										<strong>Score 60% or above:</strong> Receive a{" "}
										<strong>Certificate of Successful Completion.</strong>.
									</li>
									<li>
										✅{"  "}
										<strong>Score below 60%:</strong> Receive a Certificate of
										Participation.
									</li>
								</ul>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(4)}>
							<strong>
								4. Challenges in implementing Food Safety Standards{" "}
							</strong>
							<span className={`arrow ${activeIndex === 4 ? "open" : ""}`} />
						</div>
						{activeIndex === 4 && (
							<div className="accordin-text">
								Today’s farmers organizations and SME food businesses face big
								hurdles:
								<ul style={{ margin: "10px 0px 0px 0px" }}>
									<li>Complex certification and audit processes</li>
									<li>Limited access to reliable, hands-on guidance</li>
									<li>Low digital adoption</li>
									<li>Shortage of skilled compliance professionals</li>
								</ul>
								<p>
									Meanwhile, standard owners and certifiers can’t offer direct
									implementation help — leaving a huge gap. That’s where we come
									in. The Global Academy bridges this gap with{" "}
									<strong>
										independent, expert-led, and tech-enabled support
									</strong>{" "}
									— so you’re not just certified, your{" "}
									<strong> market-ready, profitable, and future-proof.</strong>
								</p>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(5)}>
							<strong>5. How Global Academy Addresses These Challenges</strong>
							<span className={`arrow ${activeIndex === 5 ? "open" : ""}`} />
						</div>
						{activeIndex === 5 && (
							<div className="accordin-text">
								<p>
									At the{" "}
									<strong>
										Global Academy for Food Safety and Sustainability Standards
									</strong>
									, we deliver a{" "}
									<strong>
										practical, expert-led, and technology-powered solution
									</strong>{" "}
									that bridges the critical gaps in global food safety and
									sustainability compliance.
									<br />
									<br />
									<strong>Here’s How We Make It Happen:</strong>
									<br />
									<br />
									<ul>
										<li>
											<strong>Simplifying Certification — </strong>We break down
											complex standards into clear, actionable steps so you can
											achieve certification with confidence.
										</li>
										<li>
											<strong>Expert-Led Learning — </strong>Learn at your own
											pace or join live sessions led by standards experts.
										</li>
										<li>
											<strong>Model Farms —</strong>See best practices in action
											and you can replicate success on your own farm
										</li>
										<li>
											<strong>TraceAudit™ —</strong>Our digital compliance tool
											that streamlines standards compliances , boosts
											transparency, and builds buyer & certifiers trust before
											the audit even begins.
										</li>
										<li>
											<strong>Independent Guidance —</strong> We’re not tied to
											any certification body, so you get unbiased support
											focused on your success
										</li>
									</ul>
								</p>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(6)}>
							<strong>6. Who can benefit from these courses?</strong>
							<span className={`arrow ${activeIndex === 6 ? "open" : ""}`} />
						</div>
						{activeIndex === 6 && (
							<div className="accordin-text">
								<p>Our courses are designed for:</p>
								<ul style={{ margin: "10px 0px 0px 0px" }}>
									<li>Farmers and Farmer Producer Organizations (FPOs)</li>
									<li>Food processors and exporters</li>
									<li>Agribusiness professionals</li>
									<li>Regulatory compliance managers</li>
									<li>
										Students and educators in agriculture and food sciences
									</li>
								</ul>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(7)}>
							<strong>7. Roadmap to Avail Our Services</strong>
							<span className={`arrow ${activeIndex === 7 ? "open" : ""}`} />
						</div>
						{activeIndex === 7 && (
							<div className="accordin-text">
								<ul>
									<li>
										<strong>
											How to Take Instructor-Led Courses Interested in an
											instructor-led course?
										</strong>{" "}
										Please contact us at 📧 <strong>info@krishigap.com</strong>{" "}
										to schedule and receive guidance on course availability and
										enrollment.
									</li>
									<li>
										<strong>How to Subscribe to TraceAudit™</strong> TraceAudit™
										is our digital compliance tool that streamlines standards
										compliance, boosts transparency, and builds trust with
										buyers and certifiers before the audit even begins. 👉
										Interested in using TraceAudit™? Please contact us at 📧
										<strong>info@krishigap.com</strong> for subscription
										details.
									</li>
									<li>
										<strong>Request for Model Farm Setup</strong> Interested in
										setting up a Model Farm to showcase best practices and
										demonstrate compliance with global food safety and
										sustainability standards? 👉 Please contact us at 📧
										<strong>info@krishigap.com</strong> for more information and
										to discuss partnership opportunities.
									</li>
								</ul>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(8)}>
							<strong>8. What materials are included in each course ?</strong>
							<span className={`arrow ${activeIndex === 8 ? "open" : ""}`} />
						</div>
						{activeIndex === 8 && (
							<div className="accordin-text">
								<p>
									Upon registration for a course on the Global Academy portal,
									you will gain access to implementation guidance tailored to
									the specific standard requirements. This includes: Upon
									registration for a course on the Global Academy portal, you
									will gain access to implementation guidance tailored to the
									specific standard requirements. This includes:
								</p>
								<ul style={{ margin: "10px 0px 0px 0px" }}>
									<li>A generic Quality Management System (QMS) manual.</li>
									<li>Standard Operating Procedures (SOPs).</li>
									<li>Record-keeping templates.</li>
									<li>
										Additional documentation aligned with the chosen standard.
									</li>
								</ul>
								<p>
									<strong>Please note:</strong> These resources are provided as
									generic frameworks. You are required to customize the
									documentation to suit your specific product, process, or
									operational need.
								</p>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(9)}>
							<strong>9. What Standards Are Covered ?</strong>
							<span className={`arrow ${activeIndex === 9 ? "open" : ""}`} />
						</div>
						{activeIndex === 9 && (
							<div className="accordin-text">
								<p>
									📘Course Catalogue – 2025 Edition
									<hr />
									🌐 Global Academy for Food Safety and Sustainability Standards
									<br />
									<i>
										Digitally driving India’s rise as a global leader in safe,
										sustainable, and export-ready food.
									</i>
									<hr />
									📘 Key Topics Covered in the Courses
									<ul style={{ margin: "10px 0px 0px 0px" }}>
										<li>Introduction and Course Overview</li>
										<li>Standard/Scheme Requirements</li>
										<li>Implementation Guidance</li>
										<li>Development of Quality Manuals</li>
										<li>Standard Operating Procedures (SOPs)</li>
										<li>Documentation and Record-Keeping</li>
										<li>Regulatory Requirements</li>
									</ul>
									<hr />
									<b>Delivery Format:</b> Self-paced and Instructor-led options
									available.
									<hr />
									📘 <b>How to Take an Online Course — Self-Paced</b>
									<br />
									<br />
									1️⃣ <b>Preview the Course —</b> Review the course overview to
									see if it aligns with your learning needs.
									<br />
									2️⃣ <b>Register and Pay —</b> Sign up for the course and
									complete the payment process.
									<br />
									3️⃣ <b>Access Course Materials —</b> Study at your own pace
									within the defined time period.
									<br />
									4️⃣ <b>Final Assessment —</b> Complete the final assessment
									within the course period:
									<br />
									   <b>Score 60% or above:</b> Receive a{" "}
									<b>Certificate of Successful Completion.</b>
									<br />
									   <b>Score below 60%:</b> Receive a{" "}
									<b>Certificate of Participation.</b>
									<br />
									<br />
									<b>📘 How to Take Instructor-Led Courses</b>
									<br />
									Interested in an instructor-led course? Please contact us at
									📧 <b>info@krishigap.com</b> to schedule and receive guidance
									on course availability and enrollment.
									<hr />
									<b>📚 Course Categories and Titles</b>
									<br />
									<br />
									<b> 📘 Free Courses</b>
									<br />
									<br />
									<ul style={{ margin: "0px" }}>
										<li>CABI</li>
										<li>Organic Inputs Preparation</li>
										<li>Natural Farming Guidelines- June 2025</li>
									</ul>
									📘 <b>On-Farm Production Standards</b>
									<br />
									<br />
									<b>Category:</b> On-Farm Production Standards, Organic Farming
									Standards, Specialty Crop Certification
									<br />
									<br />
									<b>Certification For:</b> Farmers, Agripreneurs, FPOs,
									Corporates, Extension Officials
									<br />
									<br />
									<b>Course Titles:</b>
									<ul style={{ marginTop: "10px" }}>
										<li>
											India Good Agricultural Practices (IndG.A.P) Certification
											for Fruits and Vegetables — Option 1 (Individual Producer
											or Farmer Group Member): Version 4.2
										</li>
										<li>
											IndG.A.P Certification for Combinable Crops — Option 1
											(Individual Producer or Farmer Group Member): Version 4.2
										</li>
										<li>
											IndG.A.P Certification for Spices — Option 1 (Individual
											Producer or Farmer Group Member): Version 4.2
										</li>
										<li>
											IndG.A.P Certification for Fruits and Vegetables — Option
											2 (Farmer Producer Group): Version 4.2
										</li>
										<li>
											GlobalG.A.P Certification for Fruits and Vegetables —
											Options 1 (Individual Producer or Farmer Group Member):
											Version 6.0
										</li>
										<li>
											GlobalG.A.P Certification for Fruits and Vegetables —
											Options 2 (Farmer Producer Group): Version 6.0
										</li>
										<li>
											USDA NOP Organic Certification for Crop Production —
											Individual Grower or Grower Group Member
										</li>
										<li>
											USDA NOP Organic Certification for Crop Production —
											Grower Group
										</li>
										<li>
											NPOP 2024 Organic Certification for Crop Production —
											Individual Grower or Grower Group Member
										</li>
										<li>
											NPOP 2024 Organic Certification for Crop Production —
											Grower Group
										</li>
										<li>
											PGS-India Group Certification for Organic Crop Production
										</li>
										<li>
											Medicinal Plants Certification Scheme — Individual Farmer
											or Farmer Producer Group
										</li>
									</ul>
									<hr />
									📘 <b>Food Safety and Standards Authority of India (FSSAI)</b>
									<br />
									<br />
									<b>Category:</b> Skill Development in FSSAI Regulatory
									Compliance
									<br />
									<br />
									<b>Certification For:</b> Food Processors, Exporters, Food
									Business Operators (FBOs)
									<br />
									<br />
									<b>Course Titles:</b>
									<ul style={{ marginTop: "10px" }}>
										<li>Catering Checklist for Compliance</li>
										<li>
											General Manufacturing: Fruits and Vegetables Checklist for
											Compliance
										</li>
										<li>
											General Manufacturing: Spices Checklist for Compliance
										</li>
										<li>Milk Production Checklist for Compliance</li>
										<li>Storage and Warehouses Checklist for Compliance</li>
									</ul>
									<hr />
									📘 <b>Post-Harvest Processing Standards</b>
									<br />
									<br />
									<b>Category:</b> Post-Harvest Processing Standards
									<br />
									<br />
									<b>Certification For:</b> Food Processors, Packhouses,
									Exporters, Traders
									<br />
									<br />
									<b>Course Titles:</b>
									<ul style={{ marginTop: "10px" }}>
										<li>ISO 22000-2018 — Food Safety Management Systems</li>
										<li>BRCGS Global Standard for Food Safety — Issue 9</li>
										<li>
											FSSC 22000 Food Safety Management Systems — Version 6
										</li>
										<li>
											BRCGS Global Standard for Packaging Materials — Issue 7
										</li>
										<li>HACCP — Codex Alimentarius</li>
										<li>ISO 9001-2015: Quality Management Systems</li>
									</ul>
									<hr />
									📘 <b>Sustainability Standards</b>
									<br />
									<br />
									<b>Category:</b> Sustainability Standards
									<br />
									<br />
									<b>Certification For:</b> Food Processors and Farms
									<br />
									<br />
									<b>Course Titles:</b>
									<ul style={{ marginTop: "10px" }}>
										<li>ISO 14001-2015 — Environmental Management Systems</li>
										<li>
											Rainforest Alliance Certification — Sustainable
											Agriculture Standard (Version 1.4)
										</li>
									</ul>
									<hr />
									📘 <b>Packhouse Recognition for Exports</b>
									<br />
									<br />
									<b>Category:</b> Packhouse Recognition
									<br />
									<br />
									<b>Certification For:</b> Food Processors, Packhouses,
									Exporters, and Traders
									<br />
									<br />
									<b>Course Title:</b>
									<ul style={{ marginTop: "10px" }}>
										<li>
											Empowering Packhouses: Enhancing Export Facilitation
										</li>
									</ul>
									<hr />
									📘{" "}
									<b>
										Skill Development for Quality Personnel — Mastering Auditing
										Principles (ISO 19011-2018)
									</b>
									<br />
									<br />
									<b>Category:</b> Other Specialized Courses
									<br />
									<br />
									<b>Certification For:</b> Internal Inspectors, Auditors
									<br />
									<br />
									<ul style={{ marginTop: "10px" }}>
										<li>
											Equip quality personnel with the knowledge and practical
											skills to conduct effective audits using ISO 19011:2018
										</li>
									</ul>
									<hr />
									📘 <b>Skill Development in Food Safety and Food Hygiene</b>
									<br />
									<br />
									<b>Category:</b> Other Specialized Courses
									<br />
									<br />
									<b>Certification For:</b> Internal Inspectors, Auditors, Food
									Processing & Packaging Personnel, Farmer Organizations
									<br />
									<br />
									<ul style={{ marginTop: "10px" }}>
										<li>
											Food Safety Essentials: Integrating HACCP Principles and
											ISO 22000:2018
										</li>
										<li>
											Food Hygiene Essentials: Integrating HACCP Principles and
											ISO 22000:2018
										</li>
									</ul>
									<hr />
									📘 <b>Skill Development for Farmers’ Organizations</b>
									<br />
									<br />
									<b>Category:</b> Farmers’ Organizations
									<br />
									<br />
									<b>Certification For:</b> CEOs and Supporting Institutions
									<br />
									<br />
									<b>Course Title:</b>
									<ul style={{ marginTop: "10px" }}>
										<li>
											Empowering Farmers’ Organizations: Standards Compliance
											and Global Market Recognition
										</li>
									</ul>
									<hr />
									📘 <b>Empowering Agripreneurs</b>
									<br />
									<br />
									<b>Category:</b> Women Agri-Preneurs’
									<br />
									<br />
									<b>Certification For:</b> Rural Women Leaders, NGOs, SHGs,
									Capacity Builders
									<br />
									<br />
									<b>Course Title:</b>
									<ul style={{ marginTop: "10px" }}>
										<li>
											Empowering Women Agri-Preneurs: Building Sustainable
											Livelihoods in Agriculture
										</li>
									</ul>
									<hr />
									📘{" "}
									<b>
										Students: Skill Development in Agriculture, Horticulture and
										Food Sciences
									</b>
									<br />
									<br />
									<b>Category:</b> Students
									<br />
									<br />
									<b>Certification For:</b> Students studying agriculture,
									horticulture and food science
									<br />
									<br />
									<b>Course Titles:</b>
									<ul style={{ marginTop: "10px" }}>
										<li>
											Course 1: Introduction to India Good Agricultural
											Practices (IndG.A.P) Certification
										</li>
										<li>Course 2: Introduction to GlobalG.A.P Certification</li>
										<li>
											Course 3: Introduction to Organic Certification (NPOP
											2024)
										</li>
										<li>
											Course 4: Introduction to Organic Certification USDA NOP
										</li>
										<li>
											Course 5: Introduction to International Food Safety
											Standards
										</li>
									</ul>
									<hr />
									📌 <b>Standards Access Notice</b>
									<br />
									<br />
									The Global Academy does not host or sell copyrighted
									standards. Users must obtain copies of the relevant standards
									directly from the respective publishers:
									<br />
									<br />
									<ul style={{ marginTop: "10px" }}>
										<li>
											ISO:{" "}
											<a
												href="https://www.iso.org"
												target="_blank"
												rel="noopener noreferrer">
												www.iso.org
											</a>
										</li>
										<li>
											BRCGS:{" "}
											<a
												href="https://www.brcgs.com"
												target="_blank"
												rel="noopener noreferrer">
												www.brcgs.com
											</a>
										</li>
										<li>
											FSSC 22000:{" "}
											<a
												href="https://www.fssc.com"
												target="_blank"
												rel="noopener noreferrer">
												www.fssc.com
											</a>
										</li>
										<li>
											GlobalG.A.P.:{" "}
											<a
												href="https://www.globalgap.org"
												target="_blank"
												rel="noopener noreferrer">
												www.globalgap.org
											</a>
										</li>
										<li>
											QCI:{" "}
											<a
												href="https://www.qcin.org"
												target="_blank"
												rel="noopener noreferrer">
												www.qcin.org
											</a>
										</li>
										<li>
											USDA:{" "}
											<a
												href="https://www.usda.gov"
												target="_blank"
												rel="noopener noreferrer">
												www.usda.gov
											</a>
										</li>
										<li>
											Rainforest Alliance:{" "}
											<a
												href="https://www.rainforest-alliance.org"
												target="_blank"
												rel="noopener noreferrer">
												www.rainforest-alliance.org
											</a>
										</li>
										<li>
											APEDA:{" "}
											<a
												href="https://www.apeda.gov.in"
												target="_blank"
												rel="noopener noreferrer">
												www.apeda.gov.in
											</a>
										</li>
										<li>
											FSSAI:{" "}
											<a
												href="https://www.fssai.org"
												target="_blank"
												rel="noopener noreferrer">
												www.fssai.org
											</a>
										</li>
									</ul>
									<hr />
								</p>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(10)}>
							<strong>10. Can I get copies of the Standards ?</strong>
							<span className={`arrow ${activeIndex === 10 ? "open" : ""}`} />
						</div>
						{activeIndex === 10 && (
							<div className="accordin-text">
								<p>
									The Global Academy does not host or sell copyrighted
									standards. Users must obtain copies of relevant standards
									directly from the respective standard publishers such as: ISO:{" "}
									<a
										href="https://www.iso.org"
										target="_blank"
										rel="noopener noreferrer">
										www.iso.org
									</a>
									, BRCGS:{" "}
									<a
										href="https://www.brcgs.com"
										target="_blank"
										rel="noopener noreferrer">
										www.brcgs.com
									</a>
									, FSSC 22000:{" "}
									<a
										href="https://www.fssc.com"
										target="_blank"
										rel="noopener noreferrer">
										www.fssc.com
									</a>
									, GlobalG.A.P:{" "}
									<a
										href="https://www.globalgap.org"
										target="_blank"
										rel="noopener noreferrer">
										www.globalgap.org
									</a>
									, QCI:{" "}
									<a
										href="https://www.qcin.org"
										target="_blank"
										rel="noopener noreferrer">
										www.qcin.org
									</a>
									, USDA:{" "}
									<a
										href="https://www.usda.gov"
										target="_blank"
										rel="noopener noreferrer">
										www.usda.gov
									</a>
									, Rainforest Alliance:{" "}
									<a
										href="https://www.rainforest-alliance.org"
										target="_blank"
										rel="noopener noreferrer">
										www.rainforest-alliance.org
									</a>
									, APEDA:{" "}
									<a
										href="https://www.apeda.gov.in"
										target="_blank"
										rel="noopener noreferrer">
										www.apeda.gov.in
									</a>
									, FSSAI:{" "}
									<a
										href="https://www.fssai.org"
										target="_blank"
										rel="noopener noreferrer">
										www.fssai.org
									</a>{" "}
									etc. Where standards are freely downloadable, we provide
									direct links to the standard publisher’s websites.
								</p>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(11)}>
							<strong>
								11. Will I receive a certificate after completing the course?
							</strong>
							<span className={`arrow ${activeIndex === 11 ? "open" : ""}`} />
						</div>
						{activeIndex === 11 && (
							<div className="accordin-text">
								<p>
									Yes! After successfully completing the final assessment within
									a course period with a score of 60% or above, you’ll receive a
									<strong> Certificate of Successful Completion</strong>. If you
									score below 60%, you’ll receive a{" "}
									<strong>Certificate of Participation.</strong>
								</p>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(12)}>
							<strong>
								12. Can I get guidance on customizing documentation for my
								product or process ?{" "}
							</strong>
							<span className={`arrow ${activeIndex === 12 ? "open" : ""}`} />
						</div>
						{activeIndex === 12 && (
							<div className="accordin-text">
								<p>
									Yes. While the provided materials are templates, our
									instructors and support team are available (for instructor-led
									courses) to guide you on adapting them to your specific needs.
									Additional consultancy services can also be arranged for
									deeper customization.
								</p>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(13)}>
							<strong>
								13. Are the courses aligned with global certification standards
								?{" "}
							</strong>
							<span className={`arrow ${activeIndex === 13 ? "open" : ""}`} />
						</div>
						{activeIndex === 13 && (
							<div className="accordin-text">
								<p>
									Absolutely. Our courses are designed based on internationally
									recognized standards, including GlobalG.A.P, IndG.A.P, USDA
									NOP, NPOP 2024, Rainforest Alliance, ISO 22000, FSSC 22000,
									BRCGS, and others.
								</p>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(14)}>
							<strong>
								14. Can I access the platform on mobile devices ?{" "}
							</strong>
							<span className={`arrow ${activeIndex === 14 ? "open" : ""}`} />
						</div>
						{activeIndex === 14 && (
							<div className="accordin-text">
								Yes. Our platform is accessible on desktop, laptop, tablet, and
								mobile devices, ensuring flexibility in learning anytime,
								anywhere.
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(25)}>
							<strong>15. Is there a free trial or demo available? </strong>
							<span className={`arrow ${activeIndex === 25 ? "open" : ""}`} />
						</div>
						{activeIndex === 25 && (
							<div className="accordin-text">
								<p>
									We currently offer course previews and overviews to help you
									understand the course structure and benefits before
									committing. Some brochures and Video shorts are available free
									of charge.
								</p>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(26)}>
							<strong>16. Who can I contact for more information? </strong>
							<span className={`arrow ${activeIndex === 26 ? "open" : ""}`} />
						</div>
						{activeIndex === 26 && (
							<div className="accordin-text">
								For more information or assistance, please email us at
								info@krishigap.com.
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(27)}>
							<strong>
								17. Can the Global Academy issue certificates of conformance to
								the standards?{" "}
							</strong>
							<span className={`arrow ${activeIndex === 14 ? "open" : ""}`} />
						</div>
						{activeIndex === 27 && (
							<div className="accordin-text">
								<p>
									No. The Global Academy does not issue certificates of
									conformance to international standards. These certificates are
									granted by accredited certification bodies approved by the
									National Accreditation Boards of respective countries—such as
									NABCB in India. Our focus is on providing skill development,
									training, and implementation support to help you meet the
									requirements and prepare for certification.
								</p>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(28)}>
							<strong>18. Regulatory Compliances Covered </strong>
							<span className={`arrow ${activeIndex === 28 ? "open" : ""}`} />
						</div>
						{activeIndex === 28 && (
							<div className="accordin-text">
								<ul>
									<li>Plant Protection Products for the Global Market</li>
									<li>Maximum Residue Levels for the Global Market</li>
									<li>Food Import Regulation for the Global Market</li>
									<li>Exporting Food from India</li>
									<li>Starting a Food Business in India</li>
									<li>Organic Food Export from India</li>
								</ul>
							</div>
						)}
					</div>

					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(29)}>
							<strong>
								19. Impact Creation Through Food Safety and Sustainability
								Standards{" "}
							</strong>
							<span className={`arrow ${activeIndex === 29 ? "open" : ""}`} />
						</div>
						{activeIndex === 29 && (
							<div className="accordin-text">
								<ul>
									<li>
										{" "}
										<strong>
											Higher incomes for certified producers —
										</strong>{" "}
										Unlock premium markets and boost profitability.
									</li>
									<li>
										{" "}
										<strong>
											Stronger food safety and export readiness —
										</strong>{" "}
										Build trust with buyers and certification bodies.
									</li>
									<li>
										<strong>Digitally skilled rural workforce —</strong> Empower
										communities with future-ready skills.
									</li>
									<li>
										<strong>
											Scalable transformation across the agri-food system —
										</strong>{" "}
										Drive sustainable change at every level.
									</li>
								</ul>
							</div>
						)}
					</div>

					<h1
						style={{
							fontSize: "22px",
							fontWeight: "600",
							letterSpacing: "0.5px",
							lineHeight: "24px",
							fontFamily: "Rubik, sans-serif",
							marginBottom: "2rem",
							marginTop: "2rem",
						}}>
						USDA Organic (NOP) FAQs
					</h1>
					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(15)}>
							<strong>1. What can be certified under USDA NOP? </strong>
							<span className={`arrow ${activeIndex === 15 ? "open" : ""}`} />
						</div>
						{activeIndex === 15 && (
							<div className="accordin-text">
								<ul>
									<li>
										Crops, Livestock, Processed Products, Wild Crops.
										<br />
										Learn more: USDA Certification Overview.
									</li>
								</ul>
							</div>
						)}
					</div>
					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(16)}>
							<strong>2. Types of USDA Organic Certificates </strong>
							<span className={`arrow ${activeIndex === 16 ? "open" : ""}`} />
						</div>
						{activeIndex === 16 && (
							<div className="accordin-text">
								<ul>
									<li>
										<strong>Organic Operation Certificate:</strong> Verifies an
										operation's organic status.
									</li>
									<li>
										<strong>NOP Import Certificate: </strong> Required for
										importing organic products into the U.S. (electronic
										issuance from March 19, 2024).
									</li>
								</ul>
							</div>
						)}
					</div>
					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(17)}>
							<strong>3. Frequency of Inspections </strong>
							<span className={`arrow ${activeIndex === 17 ? "open" : ""}`} />
						</div>
						{activeIndex === 17 && (
							<div className="accordin-text">
								<ul>
									<li>
										Inspections occur <strong>annually</strong>, with the
										possibility of <strong>unannounced inspections</strong>.
									</li>
								</ul>
							</div>
						)}
					</div>
					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(18)}>
							<strong>4. Changes in Organic Practices </strong>
							<span className={`arrow ${activeIndex === 18 ? "open" : ""}`} />
						</div>
						{activeIndex === 18 && (
							<div className="accordin-text">
								<ul>
									<li>
										Any operational change must be updated in your Organic
										System Plan (OSP) and approved by your certifier.
									</li>
								</ul>
							</div>
						)}
					</div>
					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(19)}>
							<strong> 5. Transition Period Requirements</strong>
							<span className={`arrow ${activeIndex === 19 ? "open" : ""}`} />
						</div>
						{activeIndex === 19 && (
							<div className="accordin-text">
								<ul>
									<li>
										Land must be free from prohibited substances for{" "}
										<strong> 36 months</strong> before qualifying for organic
										certification.
										<br /> More info: USDA Transition Period
									</li>
								</ul>
							</div>
						)}
					</div>
					<h1
						style={{
							fontSize: "22px",
							fontWeight: "600",
							letterSpacing: "0.5px",
							lineHeight: "24px",
							fontFamily: "Rubik, sans-serif",
							marginBottom: "2rem",
							marginTop: "2rem",
						}}>
						NPOP (National Program for Organic Production) 2024, published by
						APEDA . www.apeda.gov.in
					</h1>
					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(20)}>
							<strong> 1. What can be certified under NPOP?</strong>
							<span className={`arrow ${activeIndex === 20 ? "open" : ""}`} />
						</div>
						{activeIndex === 20 && (
							<div className="accordin-text">
								<ul>
									<li>
										Crop Production, Animal Husbandry, Apiculture, Aquaculture,
										Wild Harvest, Organic Food Processing, and Inputs
										(fertilizers, plant protection products, etc.) <br />
										Learn more:{" "}
										<a href="https://www.apeda.gov.in/">
											NPOP Certification Overview – APEDA
										</a>
									</li>
								</ul>
							</div>
						)}
					</div>
					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(21)}>
							<strong>2. Types of NPOP Organic Certificates</strong>
							<span className={`arrow ${activeIndex === 21 ? "open" : ""}`} />
						</div>
						{activeIndex === 21 && (
							<div className="accordin-text">
								<ul>
									<li>
										<strong>Scope Certificate:</strong> Issued to producers,
										processors, traders verifying compliance with NPOP
										standards.
									</li>
									<li>
										<strong>Transaction Certificate (TC):</strong> Required for
										each consignment of certified organic produce for
										traceability and trade.
									</li>
									<li>
										<strong>Accreditation Certificate:</strong> For
										Certification Bodies accredited under NPOP.
									</li>
								</ul>
							</div>
						)}
					</div>
					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(22)}>
							<strong>3. Frequency of Inspections</strong>
							<span className={`arrow ${activeIndex === 22 ? "open" : ""}`} />
						</div>
						{activeIndex === 22 && (
							<div className="accordin-text">
								<ul>
									<li>
										Inspections are conducted{" "}
										<strong>at least once annually</strong>
									</li>
									<li>
										<strong>Unannounced inspections</strong> and{" "}
										<strong>product sampling</strong> may be conducted based on
										risk assessment
									</li>
								</ul>
							</div>
						)}
					</div>
					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(23)}>
							<strong>4. Changes in Organic Practices</strong>
							<span className={`arrow ${activeIndex === 23 ? "open" : ""}`} />
						</div>
						{activeIndex === 23 && (
							<div className="accordin-text">
								<ul>
									<li>
										Any modification in farm practices, inputs, or crop systems
										must be reported to the certification body and reflected in
										the <strong>Organic Farm Management Plan (OFMP)</strong> or
										equivalent documentation
									</li>
								</ul>
							</div>
						)}
					</div>
					<div style={{ marginBottom: "10px" }}>
						<div className="accordin-heading" onClick={() => toggleSection(24)}>
							<strong>5. Transition Period Requirements</strong>
							<span className={`arrow ${activeIndex === 24 ? "open" : ""}`} />
						</div>
						{activeIndex === 24 && (
							<div className="accordin-text">
								<ul>
									<li>
										<strong>Minimum 36 months</strong> required for land
										transitioning from conventional to organic (crop
										production).
									</li>
									<li>
										For livestock and other sectors, specific conversion periods
										apply as per NPOP norms.
										<br />
										More info: Transition Guidelines – NPOP
									</li>
								</ul>
							</div>
						)}
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default Accordion;
